<template>
  <v-text-field
    v-model.trim="password"
    :rules="rules"
    :type="showPassword ? 'text' : 'password'"
    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
    :label="label"
    prepend-icon="mdi-lock-open"
    counter
    class="dover-input"
    @click:append="showPassword = !showPassword"
    @input="onPasswordChange()"/>
</template>

<script>

export default {
  props: {
    compKey: {
      type: String,
      required: true,
      default: () => []
    },
    label: {
      type: String,
      required: true,
      default: () => []
    },
    initialValue: {
      type: String,
      required: true,
      default: ''
    },
    rules: {
      type: Array,
      required: false,
      default: () => [ true, true ]
    }
  },
  data: () => ({
    showPassword: false,
    password: ''
  }),
  mounted () {
    this.password = this.initialValue
  },
  methods: {
    onPasswordChange () {
      this.$emit('onPasswordChange', this.password, this.compKey)
    }
  }
}
</script>
